






















































































































import { readUserProfile } from '@/store/main/getters';
import { Vue, Component, Prop } from 'vue-property-decorator';
import {FmvAvatar} from 'fmv-avatar';
import { api } from '@/api';
import CustomSelectInput from '@/components/vui-luma/Ui/CustomSelectInput.vue';

@Component({
  components: {
    FmvAvatar,
    CustomSelectInput,
  },
})
export default class CreateLeadModal extends Vue {
  // @ts-ignore
  @Prop({required: true, default: false}) readonly public showModal: boolean;
  public formError = false;
  public telDropdownOpen = false;
  public email = '';
  public firstName = '';
  public lastName = '';
  public country = '';
  public city = '';
  public phone = '';
  public formattedPhone = '';
  public loadingState = {
    submit: false,
  };
  public phoneError: boolean = false;

  public validateForm() {
    if ((this.email && !/(.+)@(.+){1,}\.(.+){2,}/.test(this.email)) || this.email.includes('@@')) {
      this.formError = true;
      return false;
    } else if (!this.firstName || !this.lastName || !this.country || !this.phone || this.phoneError) {
      this.formError = true;
      return false;
    } else {
      this.formError = false;
      return true;
    }
  }

  public async validatePhone(payload) {
    this.formattedPhone = payload.formattedNumber ? payload.formattedNumber : '';
    if (payload.isValid) {
      const response = await api.validateUserPhone({phone: payload.formattedNumber, user: null});
      this.phoneError = !response.data.valid;
    } else {
      this.phoneError = false;
    }
  }

  public resetForm() {
    this.email = '';
    this.firstName = '';
    this.lastName = '';
    this.country = '';
    this.city = '';
    this.phone = '';
    this.formattedPhone = '';
    this.$emit('close-modal');
  }

  public async handleSubmit() {
    if (await this.validateForm()) {
      try {
        const response = await api.createLeadManually(
          this.$store.getters.token,
          {
            email: this.email,
            first_name: this.firstName,
            last_name: this.lastName,
            country_with_flag: this.country,
            city: this.city,
            phone: this.formattedPhone,
          },
        );
        // @ts-ignore
        this.showToast(this, this.$t('Lead created'));
        this.$emit('lead-created');
        this.resetForm();
      } catch (error) {
        // @ts-ignore
        if (error.response && error.response.data) {
          let errorMsg = '';
          // @ts-ignore
          for (const [key, value] of Object.entries(error.response.data)) {
            // @ts-ignore
            errorMsg += `${this.$t(key)} - ${value[0]}\n`;
          }
          // @ts-ignore
          this.showToast(this, errorMsg, 'error');
        } else {
          // @ts-ignore
          this.showToast(this, this.$t('Error'), 'error');
        }
      }
    }
  }

  public handleChangeCountry(value) {
    // const newList: any = [];
    // for (const [key, val] of Object.entries(value)) {
    //   // @ts-ignore
    //   newList.push(val.id);
    // }
    this.country = value;
  }

  get userProfile() {
    return readUserProfile(this.$store);
  }

}
